<template>
  <div>
    <ValidationObserver ref="generateSignatureForm">
      <div class="row">
        <div class="col-12">
          <div class="custom-background">
            <div class="row">
              <div class="col-md-4 col-12  mb-3 font-weight-bold">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-input
                    id="name"
                    v-model="model.name"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    label="Nombre:"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-12  mb-3 font-weight-bold">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-input
                    id="lastName"
                    v-model="model.lastName"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    label="Primer Apellido:"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-12  mb-3 font-weight-bold">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-input
                    id="secondLastName"
                    v-model="model.secondLastName"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    label="Segundo Apellido:"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-12  mb-3 font-weight-bold">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-input
                    id="charge"
                    v-model="model.chargeName"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    label="Puesto:"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-12  mb-3 font-weight-bold">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-input
                    id="area"
                    v-model="model.area"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    label="Área:"
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-4 col-12 mb-3 font-weight-bold">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    id="participantType"
                    v-model="model.participantType"
                    :clearable="true"
                    custom-error-msg="El campo es requerido"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    label="Tipo de Participante:"
                    :options="participantTypes"
                    placeholder="Seleccione"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <div>
                <action-button
                  class="mr-2 px-3"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  variant="outline-danger"
                  @click="cancel"
                />
              </div>
              <div>
                <action-button
                  class="mr-2 px-3"
                  i="fas fa-file-plus"
                  text="Añadir"
                  variant="success"
                  @click="add"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import { getParticipantTypes } from '@/modules/proposalProcess/api.js';

export default {
  name: 'AddParticipantSignature',
  components: {
    ActionButton,
    CustomDropDown,
    CustomInput,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        name: '',
        lastName: '',
        secondLastName: '',
        chargeName: '',
        participantType: {},
        area: '',
      },
      participantTypes: [],
    };
  },
  computed: {},
  async mounted() {
    this.resetFields();
    await this.getParticipantTypes();
  },
  methods: {
    async add() {
      const isValid = await this.$refs.generateSignatureForm.validate();

      if (!isValid) return;

      const model = {
        name: this.model.name,
        lastName: this.model.lastName,
        secondLastName: this.model.secondLastName,
        chargeName: this.model.chargeName,
        participantType: this.model.participantType,
        area: this.model.area,
      };
      this.$emit('add', model);
      this.$refs.generateSignatureForm.reset();
      this.resetFields();
    },
    cancel() {
      this.$emit('cancel');
    },
    resetFields() {
      this.model = {
        name: null,
        lastName: null,
        secondLastName: null,
        chargeName: null,
        participantType: null,
        area: null,
      };
    },
    async getParticipantTypes() {
      const { data } = await getParticipantTypes();
      this.participantTypes = data;
    },
  },
};
</script>

<style scoped lang="scss">
.custom-background {
  background-color: #f7f7f7;
  padding: 1%;
}
</style>
